import { api } from './client';
import type { AppConfig, AuthIdentity } from './types';

// Slice 1: Bootstrap-Endpunkte. Folge-Slices fügen acts/posts/chat/expenses etc. dazu.

/**
 * GET /trips/<slug>/api/config
 *
 * Liefert die Trip-Meta-Daten, VAPID-Public-Key, Admin-Flag und Chat-Toggle
 * in einem Roundtrip. Ersetzt die alten `window.TRIP_CONFIG`-Inline-Injections
 * aus den server-gerenderten HTML-Seiten.
 */
export function fetchConfig(slug: string, signal?: AbortSignal): Promise<AppConfig> {
  return api.get<AppConfig>(`/trips/${encodeURIComponent(slug)}/api/config`, { signal });
}

/**
 * GET /trips/<slug>/api/auth/me
 *
 * Liefert immer 200 — ohne gültige Session steht `loggedIn: false` im Body,
 * sonst kommt der Identity-Payload zurück.
 */
export function fetchIdentity(slug: string, signal?: AbortSignal): Promise<AuthIdentity> {
  return api.get<AuthIdentity>(`/trips/${encodeURIComponent(slug)}/api/auth/me`, { signal });
}
